import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=ce6aa564&scoped=true"
import script from "./UserHistory.vue?vue&type=script&lang=js"
export * from "./UserHistory.vue?vue&type=script&lang=js"
import style0 from "./UserHistory.vue?vue&type=style&index=0&id=ce6aa564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6aa564",
  null
  
)

export default component.exports